import ExpressionLanguage from 'gw-portals-exp-lang-js';
import 'gw-portals-metadata-angular';

export default ['TranslateService', 'InsuranceSuiteMetadata', function (TranslateService, InsuranceSuiteMetadata) {
    return ExpressionLanguage.createExpressionLanguage(function () {
        var displayKey = arguments[0];
        var transKeys = {};
        for (var i = 1; i < arguments.length; i++) {
            transKeys['_' + (i - 1)] = arguments[i];
        }
        return TranslateService.instant(displayKey, transKeys);
    }, function (xCenter, typekey, typecode) {
        return InsuranceSuiteMetadata.get(xCenter).types.get('typelist', 'typekey.' + typekey).getCode(typecode);
    });
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-exp-lang-angular/ExpressionLanguageService.js
// module id = 884
// module chunks = 0